import getInitial from 'owa-persona/lib/utils/getInitial';
import getTextBoyColor from 'owa-persona/lib/utils/getTextBoyColor';
import PersonaType from 'owa-service/lib/contract/PersonaType';
import { getLocalizedAddress } from './getLocalizedAddress';
import { getLocationDisplayText } from './getLocationDisplayText';
import { getLocationPostalAddress } from './getLocationPostalAddress';
import { isNullOrWhiteSpace } from 'owa-string-utils';
import { LocationPersonaControlViewState } from '../data/schema/LocationPersonaControlViewState';

/**
 * Create location persona from a personaType
 * @param persona: the persona type
 */
export function createLocationPersonaFromPersonaType(
    persona: PersonaType
): LocationPersonaControlViewState {
    if (persona) {
        let postalAddress = getLocationPostalAddress(persona);
        let displayText = getLocationDisplayText(persona.DisplayName, postalAddress);

        if (persona.PersonaTypeString == 'Room') {
            postalAddress.LocationUri = persona.EmailAddress.EmailAddress;
        }

        return {
            personaId: persona.PersonaId && persona.PersonaId.Id,
            feedbackId: persona.FeedbackId,
            displayName: displayText,
            postalAddress: postalAddress,
            emailAddress: persona.EmailAddress,
            displayAddress: getLocalizedAddress(postalAddress),
            initials: getInitial(displayText),
            textBoyColor: getTextBoyColor(displayText),
            selectionSource: 'LocationWell',
            personaType: isNullOrWhiteSpace(persona.PersonaTypeString)
                ? 'Unknown'
                : persona.PersonaTypeString,
            personaControlId: persona.PersonaId == null ? persona.FeedbackId : persona.PersonaId.Id,
            availability: persona.Availability,
        };
    }
    return null;
}
